import { getNow, getTime } from '~/helpers/time';
import partner01 from '~/images/awards2024/index/partners/strategic_partners01.png';
import partner02 from '~/images/awards2024/index/partners/strategic_partners02.png';
import partner03 from '~/images/awards2024/index/partners/media_partners01.png';
import partner04 from '~/images/awards2024/index/partners/media_partners02.png';
import partner05 from '~/images/awards2024/index/partners/media_partners03.png';
import partner06 from '~/images/awards2024/index/partners/media_partners04.png';
import partner07 from '~/images/awards2024/index/partners/media_partners05.png';
import partner08 from '~/images/awards2024/index/partners/media_partners06.png';
import partner09 from '~/images/awards2024/index/partners/media_partners07.png';
import partner10 from '~/images/awards2024/index/partners/media_partners08.png';
import partner11 from '~/images/awards2024/index/partners/media_partners09.png';
import partner12 from '~/images/awards2024/index/partners/media_partners10.png';
import partner01mb from '~/images/mobile/awards2024/partners/strategic_partners01.png';
import partner02mb from '~/images/mobile/awards2024/partners/strategic_partners02.png';
import partner03mb from '~/images/mobile/awards2024/partners/media_partners01.png';
import partner04mb from '~/images/mobile/awards2024/partners/media_partners02.png';
import partner05mb from '~/images/mobile/awards2024/partners/media_partners03.png';
import partner06mb from '~/images/mobile/awards2024/partners/media_partners04.png';
import partner07mb from '~/images/mobile/awards2024/partners/media_partners05.png';
import partner08mb from '~/images/mobile/awards2024/partners/media_partners06.png';
import partner09mb from '~/images/mobile/awards2024/partners/media_partners07.png';
import partner10mb from '~/images/mobile/awards2024/partners/media_partners08.png';
import partner11mb from '~/images/mobile/awards2024/partners/media_partners09.png';
import partner12mb from '~/images/mobile/awards2024/partners/media_partners10.png';
import judge01 from '~/images/awards2024/index/judges/01_osama.png';
import judge02 from '~/images/awards2024/index/judges/02_amanda.png';
import judge03 from '~/images/awards2024/index/judges/03_marco.png';
import judge04 from '~/images/awards2024/index/judges/04_philomena.png';

interface FlowDatum {
  name: string;
  date: string;
}

interface Judge {
  name: string;
  title: string;
  avatar: string;
}

interface partner {
  name: string;
  img: string;
  imgMb: string;
}

export function getRouteOption(top = 600) {
  return { state: { type: 'scroll', top }, preventScrollReset: true };
}

/* 赛事流程 */
export type MatchFlowType = 1 | 2 | 3 | 4 | 5 | 0;

export function getFlowDatumData(): {
  current: MatchFlowType;
  data: FlowDatum[];
} {
  const data = [
    {
      name: 'SUBMISSION\nPERIOD',
      date: '3.24-7.15',
    },
    {
      name: 'PRELIMINARIES',
      date: '7.16-8.15',
    },
    {
      name: 'SHORTLISTING',
      date: '8.16-9.15',
    },
    {
      name: 'FINAL\nJUDGING',
      date: '9.16-11.20',
    },
    {
      name: 'LIVE AWARDS\nCEREMONY',
      date: '11.22',
    },
  ];
  const now = getNow();
  let current: MatchFlowType = 1;
  if (now >= getTime('2024/3/24') && now <= getTime('2024/7/15')) {
    current = 1;
  } else if (now >= getTime('2024/7/16') && now <= getTime('2024/8/15')) {
    current = 2;
  } else if (now >= getTime('2024/8/16') && now <= getTime('2024/9/15')) {
    current = 3;
  } else if (now >= getTime('2024/9/16') && now <= getTime('2024/10/15')) {
    current = 4;
  } else if (now >= getTime('2024/10/22')) {
    current = 5;
  }
  return { current, data };
}

/* 赛事评委 */
export const judges: Judge[] = [
  {
    name: 'Osama Dorias',
    title: 'Lead Gameplay Designer, Brass Lion Entertainment',
    avatar: judge01,
  },
  {
    name: 'Amanda Farough',
    title: 'Narrative Designer & Game Writer',
    avatar: judge02,
  },
  {
    name: 'Marco Conrad',
    title: 'CEO, Indiesquire',
    avatar: judge03,
  },
  {
    name: 'Philomena Schwab',
    title: 'Co-founder, Stray Fawn Studio',
    avatar: judge04,
  },
];

/* 合作伙伴 */
export const partners: partner[] = [
  {
    name: '合作伙伴01',
    img: partner01,
    imgMb: partner01mb,
  },
  {
    name: '合作伙伴02',
    img: partner02,
    imgMb: partner02mb,
  },
  {
    name: '合作伙伴03',
    img: partner03,
    imgMb: partner03mb,
  },
  {
    name: '合作伙伴04',
    img: partner04,
    imgMb: partner04mb,
  },
  {
    name: '合作伙伴05',
    img: partner05,
    imgMb: partner05mb,
  },
  {
    name: '合作伙伴06',
    img: partner06,
    imgMb: partner06mb,
  },
  {
    name: '合作伙伴07',
    img: partner07,
    imgMb: partner07mb,
  },
  {
    name: '合作伙伴08',
    img: partner08,
    imgMb: partner08mb,
  },
  {
    name: '合作伙伴09',
    img: partner09,
    imgMb: partner09mb,
  },
  {
    name: '合作伙伴10',
    img: partner10,
    imgMb: partner10mb,
  },
  {
    name: '合作伙伴11',
    img: partner11,
    imgMb: partner11mb,
  },
  {
    name: '合作伙伴12',
    img: partner12,
    imgMb: partner12mb,
  },
];
